import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import t from '@/utils/Language/ResourceCard-translations';
import classes from './OpenNow.module.scss';
import { DateHelper } from '@/utils/helpers';
import { resourceHelpers } from '@/utils/helpers';

const OpenNow = ({ location, ...props }) => {
  // primaryNextOpen depends on the wall clock and the process timezone, which differ between
  // the SSR server and the member's browser. Compute it only after mount so the server and
  // the first client render both produce nothing and hydration stays consistent.
  const [nextOpen, setNextOpen] = useState(null);

  useEffect(() => {
    setNextOpen(resourceHelpers.primaryNextOpen(location, DateHelper));
  }, [location]);

  return (
    <>
      {nextOpen && (
        <div className={classes?.aboutSectionTiming}>
          <span className={nextOpen.now ? classes.openNow : classes.address}>
            <FontAwesomeIcon icon="fa-solid fa-circle" className={classes.dot} />
            {nextOpen.now ? t('Open Now') : t('Will open at')}: {`${t(nextOpen.dayAbbrev)} ${nextOpen.startTime}-${nextOpen.endTime}`}
          </span>
        </div>
      )}
    </>
  );
};

export default OpenNow;
